import { postLog } from '@/api/postLog'
import { dataTypes } from '@/constants/healthDataTypes'

const endDate = new Date()
const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())

export const checkIfAvailable = async () => {
  return await new Promise((resolve, reject) => {
    window?.cordova?.plugins?.health?.isAvailable((res) => {
      postLog({ m: 'isAvailable success', res: JSON.stringify(res) })
      if (res === true || res.toLowerCase() === 'ok') {
        resolve(true)
      } else {
        resolve(res)
      }
    }, (err) => {
      postLog({
        m: 'isAvailable failed',
        error: err
      })
      reject(err)
    })
  })
}

export const checkIfAuthorized = async () => {
  return await new Promise((resolve, reject) => {
    window?.cordova?.plugins?.health?.isAuthorized({ read: dataTypes }, (res) => {
      postLog({ m: 'isAuthorized success', res: JSON.stringify(res) })
      resolve(res)
    }, (error) => {
      postLog({
        m: 'isAuthorized failed',
        error: error
      })
      reject(error)
    })
  })
}

export const requestAuthorization = async () => {
  return await new Promise((resolve, reject) => {
    window?.cordova?.plugins?.health?.requestAuthorization({ read: dataTypes }, (res) => {
      postLog({ m: 'requestAuthorization success', res: JSON.stringify(res) })
      const result = res === true
      resolve(result)
    }, (error) => {
      postLog({
        m: 'isAuthorized failed',
        error: error
      })
      reject(error)
    })
  })
}

export const getHealth = async (dataType) => {
  return await new Promise((resolve, reject) => {
    window.cordova?.plugins?.health?.queryAggregated({
      startDate: startDate,
      endDate: endDate,
      dataType: dataType,
      bucket: 'day'
    }, (data) => {
      postLog({
        m: 'queryAggregated success',
        data: data,
        dataType: dataType
      })
      resolve(data)
    }, (err) => {
      postLog({
        m: 'queryAggregated failed',
        error: err,
        dataType: dataType
      })
      reject(err)
    })
  })
}

export const getHealthSinceMonth = async (dataType) => {
  return await new Promise((resolve, reject) => {
    window.cordova?.plugins?.health?.queryAggregated({
      startDate: new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      dataType: dataType,
      bucket: 'day'
    }, (data) => {
      postLog({
        m: 'queryAggregated success',
        data: data,
        dataType: dataType
      })
      resolve(data)
    }, (err) => {
      postLog({
        m: 'queryAggregated failed',
        error: err,
        dataType: dataType
      })
      reject(err)
    })
  })
}

export const getHealthQuery = async (dataType) => {
  return await new Promise((resolve, reject) => {
    window.cordova?.plugins?.health?.query({
      startDate: new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000),
      endDate: new Date(),
      dataType: dataType,
      limit: 1000
    }, (data) => {
      postLog({
        m: 'query success',
        data: data,
        dataType: dataType
      })
      resolve(data)
    }, (err) => {
      postLog({
        m: 'query failed',
        error: err,
        dataType: dataType
      })
      reject(err)
    })
  })
}

export const checkStepsAccessForIos = async () => {
  try {
    const res = await getHealthQuery(['steps'])
    return res?.length > 0
  } catch (error) {
    console.error('Global health check error:', error)
    return false
  }
}

export const requestHealthAuthorization = async () => {
  const platform = window?.device?.platform.toLowerCase()
  if (platform === 'ios' || platform === 'android') {
    const isAvailable = await checkIfAvailable()
    if (isAvailable === true) {
      await requestAuthorization()
      localStorage.setItem('health_initialized', 'true')
    }
    return await getHealthAccessStatus()
  }
}

export const getHealthAccessStatus = async () => {
  try {
    const platform = window?.device?.platform.toLowerCase()

    if (platform === 'ios' || platform === 'android') {
      const isAvailable = await checkIfAvailable()

      if (platform === 'android') {
        const isAuthorized = await checkIfAuthorized()
        return isAvailable && isAuthorized
      } else if (platform === 'ios') {
        const areStepsAvailable = await checkStepsAccessForIos()
        return isAvailable && areStepsAvailable
      }
    } else {
      return false
    }
  } catch (err) {
    return false
  }
}

export const goToHealthSystemApp = () => {
  if (window.cordova?.plugins?.health) {
    const platform = window?.device?.platform.toLowerCase()
    window.cordova.plugins.health.openHealthSettings(
      (data) => {
        if (platform === 'android') {
          postLog({
            m: 'openHealthSettings success on Android',
            data
          })
        }
      },
      (err) => {
        if (platform === 'android') {
          postLog({
            m: 'openHealthSettings failed on Android',
            error: err
          })
        }
      }
    )
  }
}

// import { ref } from 'vue'
// import { postLog } from '@/api/postLog'

// const dataTypes = ['steps', 'distance', 'calories', 'weight', 'height', 'activity']

// const endDate = new Date()
// const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())

// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// export const useHealth = () => {
//   const steps = ref(null)
//   const distance = ref(null)
//   const calories = ref(null)
//   const isHealthAvailable = ref(false)

//   const checkIfAvailable = async () => {
//     return await new Promise((resolve, reject) => {
//       window?.cordova?.plugins?.health?.isAvailable((res) => {
//         postLog({ m: 'isAvailable success', res: JSON.stringify(res) })
//         resolve(res === true || res?.toLowerCase?.() === 'ok')
//       }, (err) => {
//         postLog({ m: 'isAvailable failed', error: err })
//         reject(err)
//       })
//     })
//   }

//   const checkIfAuthorized = async () => {
//     return await new Promise((resolve, reject) => {
//       window?.cordova?.plugins?.health?.isAuthorized({ read: dataTypes }, (res) => {
//         postLog({ m: 'isAuthorized success', res: JSON.stringify(res) })
//         resolve(res)
//       }, (error) => {
//         postLog({ m: 'isAuthorized failed', error })
//         reject(error)
//       })
//     })
//   }

//   const requestAuthorization = async () => {
//     return await new Promise((resolve, reject) => {
//       window?.cordova?.plugins?.health?.requestAuthorization({ read: dataTypes }, (res) => {
//         postLog({ m: 'requestAuthorization success', res: JSON.stringify(res) })
//         resolve(res === true)
//       }, (error) => {
//         postLog({ m: 'requestAuthorization failed', error })
//         reject(error)
//       })
//     })
//   }

//   const getHealth = async (dataType) => {
//     return await new Promise((resolve, reject) => {
//       window.cordova?.plugins?.health?.queryAggregated({
//         startDate,
//         endDate,
//         dataType,
//         bucket: 'day'
//       }, (data) => {
//         postLog({ m: 'queryAggregated success', data, dataType })
//         resolve(data)
//       }, (err) => {
//         postLog({ m: 'queryAggregated failed', error: err, dataType })
//         reject(err)
//       })
//     })
//   }

//   const getHealthQuery = async (dataType) => {
//     return await new Promise((resolve, reject) => {
//       window.cordova?.plugins?.health?.query({
//         startDate: new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000),
//         endDate: new Date(),
//         dataType,
//         limit: 1000
//       }, (data) => {
//         postLog({ m: 'query success', data, dataType })
//         resolve(data)
//       }, (err) => {
//         postLog({ m: 'query failed', error: err, dataType })
//         reject(err)
//       })
//     })
//   }

//   const checkStepsAccessForIos = async () => {
//     try {
//       const res = await getHealthQuery(['steps'])
//       return res?.length > 0
//     } catch (error) {
//       console.error('Global health check error:', error)
//       return false
//     }
//   }

//   const requestHealthAuthorization = async () => {
//     const isHealthInitialized = JSON.parse(localStorage.getItem('health_initialized'))
//     const platform = window?.device?.platform?.toLowerCase()

//     if (platform === 'ios' || platform === 'android') {
//       const isAvailable = await checkIfAvailable()
//       if (isAvailable && !isHealthInitialized) {
//         await requestAuthorization()
//         localStorage.setItem('health_initialized', 'true')
//         await sleep(2000)
//       }
//       return await getHealthAccessStatus()
//     }
//   }

//   const getHealthAccessStatus = async () => {
//     try {
//       const platform = window?.device?.platform?.toLowerCase()
//       const isAvailable = await checkIfAvailable()

//       if (platform === 'android') {
//         const isAuthorized = await checkIfAuthorized()
//         return isAvailable && isAuthorized
//       } else if (platform === 'ios') {
//         const stepsAvailable = await checkStepsAccessForIos()
//         return isAvailable && stepsAvailable
//       } else {
//         return false
//       }
//     } catch (err) {
//       return false
//     }
//   }

//   const goToHealthSystemApp = () => {
//     if (window.cordova?.plugins?.health) {
//       window.cordova.plugins.health.openHealthSettings()
//     }
//   }

//   const updateHealthValues = async () => {
//     steps.value = await getHealth('steps')
//     distance.value = await getHealth('distance')
//     calories.value = await getHealth('calories')
//   }

//   return {
//     steps,
//     distance,
//     calories,
//     isHealthAvailable,
//     requestHealthAuthorization,
//     getHealthAccessStatus,
//     goToHealthSystemApp,
//     updateHealthValues
//   }
// }
